import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const ContactNameInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Nombre">
      {getFieldDecorator("contactName", {
        rules: [
          {
            required: true,
            message: "Por favor, ingresa el nombre del contacto."
          }
        ],
        initialValue: implementerProfile?.contactName
      })(
        <Input
          disabled={isBusy}
          id="contactName"
          name="contactName"
          placeholder="Nombre"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
